<div class="main-container-left-side">
  <left-sport-menu-desktop></left-sport-menu-desktop>
</div>

<div class="main-container-mid-side">
  <div class="container">
    <div class="header">
      <div class="header-text">
        {{ 'Recover_password' | t }}
      </div>
      <div class="arrow-icon down"></div>
    </div>
    <div class="content">
      <div class="sports-container recover-password">
        <form class="example-form" [formGroup]="recoverPasswordDatas">
          <inputb3
            formControlName="newPassword"
            extraClass="profileInputs"
            fPlaceholder="{{ 'NewPassword' | t }}"
            fErrorText="{{ 'Register_Password_Info' | t }}"
            fInputType="password"></inputb3>
          <inputb3
            formControlName="reNewPassword"
            extraClass="profileInputs"
            fErrorText="{{ 'Register_Re_Password_Same_Error' | t }}"
            fPlaceholder="{{ 'NewRePassword' | t }}"
            fInputType="password"></inputb3>
        </form>

        <div style="display: flex; padding: 6px">
          <div
            *ngIf="this.recoverPasswordDatas.valid; else validPasswordForClosure"
            class="btn colored register-button save-changes-button"
            style="width: 100% !important"
            (click)="submitRecoverPasswordData()">
            <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
          </div>
          <ng-template #validPasswordForClosure>
            <div class="btn colored register-button save-changes-button" style="width: 100% !important; opacity: 0.65" (click)="submitRecoverPasswordData()">
              <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
